// extracted by mini-css-extract-plugin
export default {"intersectionPoint":"intersection-point-module__intersectionPoint___f-HhF"};